import React from 'react';
export default function Ribbon({ side, color }) {
    const colors = {
        black: '#000',
        white: '#fff',
        primary: 'primary',
    };
    if (!color) {
        color = side == 'left' ? 'black' : 'white';
    }
    const bgColor = colors[color || 'black'];
    return (React.createElement("div", { className: `ltg-ribbon ${(side == 'top' || side == 'bottom') ? 'flex-column' : ''}` },
        (side == 'left' || side == 'top') && React.createElement("div", { className: `string ${'string-' + side} bg-${color}`, style: { background: bgColor } }),
        React.createElement("div", { className: "knot-wrap" },
            React.createElement("div", { className: `knot bg-${color}`, style: { background: bgColor } })),
        (side == 'right' || side == 'bottom') && React.createElement("div", { className: `string ${'string-' + side} bg-${color}`, style: { background: bgColor } })));
}
